import type { ServiceReservationDto } from '@hcr/api/consumer'

export const createActivityServiceReservationValidityString = ({ name, quantity }: ServiceReservationDto): string =>
  quantity > 1 ? `${name} x${quantity}` : name
